import { Action, State, StateContext } from '@ngxs/store';
import * as actions from './word-guess-puzzle.actions';
import { patch } from '@ngxs/store/operators';
import { WordGuessPuzzleStateModel } from './word-guess-puzzle-state.model';
import { Injectable } from '@angular/core';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';
// @dynamic
@State<WordGuessPuzzleStateModel>({
  name: 'wordGuessPuzzleState',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class WordGuessPuzzleState extends PuzzleGameBaseState {
  @Action(actions.InitWordGuessPuzzle)
  InitWordGuessPuzzle(state: StateContext<WordGuessPuzzleStateModel>, { payload }: actions.InitWordGuessPuzzle) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistWordGuessState)
  PersistWordGuessState(state: StateContext<WordGuessPuzzleStateModel>, { payload }: actions.PersistWordGuessState) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            guesses: payload.guesses,
          }),
        }),
      })
    );
  }
}
